import { getOrganizationMasterServiceAgreementDetailsApi } from '@/api/v1/opco/organizations/getOrganizationMasterServiceAgreementDetailsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const getOrganizationMasterServiceAgreementDetails = async (organizationId: string) => {
  try {
    const response = await getOrganizationMasterServiceAgreementDetailsApi(organizationId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
